/**
 * Overrides each team's `creditBalance` in the PaymentsInvoice team-credit list
 * with the Finance ledger's per-team `creditsRemaining` when the finance ledger
 * is enabled.
 *
 * Why: under the finance ledger the legacy `team.creditBalance` is 0 (credits
 * are now system-of-record in the Finance app), which made the Review
 * Submission "Select the team…" dropdown show "0 Credits Available" for every
 * team. Teams absent from the ledger resolve to 0 (never omitted) — mirrors
 * buildFinanceTeamRows / the Credits dropdown.
 *
 * TeamCredits renders `creditBalance.balance + creditBalance.rolloverBalance`,
 * so the ledger value is written as `balance` with `rolloverBalance: 0`.
 *
 * Pure function — no side-effects, safe to unit-test without a render.
 *
 * @param {Object}  params
 * @param {boolean} params.enabled        - financeLedgerEnabled flag
 * @param {Array}   params.teamCreditInfo - [{ team: { teamId, creditBalance, ... }, ... }]
 * @param {Array}   params.teamBalances   - [{teamId, teamName, creditsRemaining}] from getFinanceBalance
 * @return {Array} teamCreditInfo with finance-sourced creditBalance (unchanged when disabled)
 */
export default function applyFinanceTeamCredits({
  enabled,
  teamCreditInfo = [],
  teamBalances
}) {
  if (!enabled || !teamBalances) return teamCreditInfo;

  return teamCreditInfo.map((entry) => {
    const ledger = teamBalances.find((t) => t.teamId === entry.team.teamId);
    return {
      ...entry,
      team: {
        ...entry.team,
        creditBalance: {
          ...entry.team.creditBalance,
          balance: ledger ? Number(ledger.creditsRemaining) || 0 : 0,
          rolloverBalance: 0
        }
      }
    };
  });
}
